import React from "react";
import "./filtros.sass";

export default function FiltrosComponent(
    { seleccionarFiltroCompetencias,
        dataCompetencias,
        seleccionarFiltroPais,
        dataPaises,
        handleClickMostrar,
        handleClickOcultar,
        seleccionarFiltroFecha,
        dataFechas,
        disminuirFecha,
        aumentarFecha,
        valorFiltroFechas,
        showLoading,
        desactivar,
        componenteActual,
        seleccionarFiltroENVIVO,
        valorFiltroENVIVO
    }) {

    return (

        <div className={"container-filtros "+ componenteActual} id={"filtros-"+ componenteActual}>
            {/* SELECT DEPORTES / COMPETENCIAS */}
            <div className="select-filtro-competencia">
                <select onChange={seleccionarFiltroCompetencias}>
                    {dataCompetencias &&
                        dataCompetencias.map((competencia) => (
                            <option key={competencia.id} value={competencia.slug}>
                                {competencia.name}
                            </option>
                        ))}
                </select>
            </div>

            {/* SELECT POR PAIS */}
            <div className="select-filtro-pais">
                <select onChange={seleccionarFiltroPais} disabled={desactivar}>
                    {dataPaises &&
                        dataPaises.map((pais) => (
                            <option key={pais.id} value={pais.slug}>
                                {pais.name}
                            </option>
                        ))}
                </select>
            </div>

            {/* ABRIR - OCULTAR BOTONES */}
            <div className="select-filtro-abrir-colapsar">
                <div className="open-eventos" onClick={handleClickMostrar}>
                    <span>Abrir </span> todos
                </div>
                <div className="center-openClose">/</div>
                <div className="close-eventos" onClick={handleClickOcultar}>
                    <span>Colapsar </span>todos
                </div>
            </div>

            {/* VER EN VIVO SWITCH */}
            {(componenteActual === 'paris') && 
                <div className="filtro-envivo" onClick={seleccionarFiltroENVIVO}>
                    <div className="switch" >
                        <div className={`switch-knob ${valorFiltroENVIVO ? 'on' : 'off'}`}></div>
                    </div>
                    <p className={`textSwitch ${valorFiltroENVIVO ? 'on' : 'off'}`}>En vivo</p>
                </div>
            }

            {/* SELECT FECHAS  */}
            <div className="container-filtro-fecha">
                <button onClick={disminuirFecha} id="disminuir" disabled={desactivar}>
                    <div className="btn-arrow-left" >
                    </div>
                </button>
                

                <div className="select-filtro-fecha">
                    <select onChange={seleccionarFiltroFecha} disabled={desactivar}>
                        {dataFechas &&
                            dataFechas.map((fecha) => (
                                <option
                                    key={fecha.id}
                                    value={fecha.value}
                                    selected={fecha.value === valorFiltroFechas}
                                >
                                    {fecha.name}
                                </option>
                            ))}
                    </select>
                </div>

                <button onClick={aumentarFecha} id="aumentar" disabled={desactivar}>
                    <div className="btn-arrow-right"></div>
                </button>
            </div>
        </div>

    );
}
